import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import { UserContextProvider } from "./context/UserContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
// * Create a Query client for the application and provide it to the query client provider
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

if (process.env.REACT_APP_NODE_ENV === "dev") {
  ReactGA.initialize("G-G6W7HHPT1L");
  let location = window.location.href;
  if (location.includes("owp-dw-dev.saclink.csus.edu")) {
    const DEVELOPER_PORTS = {
      8016: "DEV",
      8032: "Alekya",
      8025: "Sofiya",
      8040: "Alex",
      8054: "Vikas",
      8052: "Sasi",
      8028: "Varun",
    };
    let startOfPort = location.indexOf(":", 6);
    let port_num = location.substring(startOfPort + 1, startOfPort + 5);
    let developer_name = DEVELOPER_PORTS[port_num] || "Unknown Port";
    document.title = "PFAS (" + developer_name + ")";
  }
  else if (process.env.REACT_APP_NODE_ENV === "local") {
    document.title = "PFAS (localhost)";
  }
}

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <UserContextProvider>
          <App />
        </UserContextProvider>
      </AuthContextProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

const SendAnalytics = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
